<app-chart-wrapper [isLoading]="isLoading" [title]="'Write-Offs'" [showTotal]="true" [total]="total" (fullscreen)="hideFilters = $event">

    <!-- Filters -->
    <form filter [formGroup]="form" class="flex gap-1 mb-4" [ngClass]="showSortControl?'justify-between':'justify-end'">

        <ng-container *ngIf="showSortControl">
            <button mat-button [matMenuTriggerFor]="sorting" class="sort-btn">
                {{ sortLabel }}
                <img class="ml-2.5 h-5" src="assets/icons/sort-order.svg" alt="" />
              </button>
            <mat-menu #sorting="matMenu">
                <button mat-menu-item *ngFor="let option of sortOptions" (click)="onSort(option)">
                  {{ option.label }}
                </button>
            </mat-menu>
        </ng-container>

        <app-loan-product-search-select [disabled]="hideFilters" class="w-[40%] bg-white" (emitSelectedVal)="filterWriteOffs({ type: reportsInput.LOAN_PRODUCT, value: $event?.id })" [control]="productCtrl" type="client">
        </app-loan-product-search-select>


    </form>
    <!-- End Filters -->
    <app-circle-chart chart *ngIf="writeOffChartData?.length === 1 && !isLoading" [width]="'50px'" [height]="'50px'" [totalAmount]="writeOffChartData[0]?.value ?? 0" [imageName]="'hand-write-off'" [classNames]="'text-primary'">
    </app-circle-chart>

    <app-no-data-to-show chart *ngIf="!writeOffChartData?.length && !isLoading"></app-no-data-to-show>
    <!-- 
    <app-doughnut-chart chart *ngIf="numberOfTenantBranches > 1 && numberOfTenantBranches < 5"
        [chartData]="writeOffChartData"
        [palette]="writeOffPalette"
    ></app-doughnut-chart> -->


    <app-column-chart chart *ngIf="writeOffChartData?.length > 1 && !isLoading" [chartData]="writeOffChartData" [sortingOptions]="writeOffSortingOptions">
    </app-column-chart>
</app-chart-wrapper>